import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
const options = [{
  id: 'standard',
  icon: '🔹',
  label: 'OPCIÓN 1',
  title: 'SUPER COMBO PRO',
  oldPrice: '$34.990',
  price: '$19.990 ARS',
  url: 'https://solucionstore.shop/cart/45476813504703:1',
  features: ['6 Tomos completos', '6 Bonos estratégicos', 'Garantía 7 días'],
  cta: 'QUIERO EL SUPER COMBO POR $19.990'
}, {
  id: 'premium',
  icon: '🔶',
  label: 'OPCIÓN 2',
  badge: '⭐ MÁS ELEGIDA',
  title: 'COMBO COMPLETO',
  oldPrice: '$43.990',
  price: '$27.990 ARS',
  url: 'https://solucionstore.shop/cart/45476839882943:1',
  features: ['Todo lo del Super Combo', 'Sistema Micro-Fábrica™ (50 páginas)', 'Fabricá x3 más rápido con Jigs Maestros', 'Producción por lotes: 5 muebles en 1 semana', 'Plan de 90 días para escalar tu taller', 'Fórmula de costos con ayudante incluida', 'Garantía 7 días'],
  cta: 'QUIERO EL COMBO COMPLETO POR $27.990'
}];
export function Pricing() {
  const [selected, setSelected] = useState('premium');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="comprar" className="py-12 md:py-16 bg-charcoal relative" data-id="element-160">
      <div className="container mx-auto px-4" data-id="element-161">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-black text-white mb-10 text-center" data-id="element-162">
          ELEGÍ TU <span className="text-amber" data-id="element-163">COMBO</span>
        </motion.h2>

        <div className="max-w-2xl mx-auto space-y-4 mb-8" data-id="element-164">
          {options.map(option => {
          const isSelected = selected === option.id;
          return <motion.button key={option.id} type="button" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 cursor-pointer relative ${isSelected ? 'border-amber bg-wood-dark/80 shadow-[0_0_20px_rgba(245,197,66,0.15)]' : 'border-white/10 bg-wood-dark/40 hover:border-white/25'}`} data-id="element-165">
                {option.badge && <span className="absolute -top-3 right-4 bg-amber text-wood-dark text-xs font-black px-3 py-1 rounded-full tracking-wider" data-id="element-166">
                    {option.badge}
                  </span>}

                <div className="flex items-start gap-3" data-id="element-167">
                  <div className="mt-1 flex-shrink-0" data-id="element-168">
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-amber' : 'border-white/30'}`} data-id="element-169">
                      {isSelected && <motion.div initial={{
                    scale: 0
                  }} animate={{
                    scale: 1
                  }} className="w-2.5 h-2.5 rounded-full bg-amber" data-id="element-170" />}
                    </div>
                  </div>

                  <div className="flex-grow min-w-0" data-id="element-171">
                    <div className="flex items-center gap-2 mb-0.5" data-id="element-172">
                      <span className="text-xl" data-id="element-173">{option.icon}</span>
                      <span className="text-xs text-white/50 font-bold uppercase tracking-wider" data-id="element-174">
                        {option.label}
                      </span>
                    </div>
                    <h3 className="text-lg md:text-xl font-black text-white leading-tight mb-3" data-id="element-175">
                      {option.title}
                    </h3>

                    <div className="mb-3" data-id="element-176">
                      <span className="text-white/40 line-through text-sm mr-2" data-id="element-177">
                        {option.oldPrice}
                      </span>
                      <span className="text-2xl md:text-3xl font-black text-amber" data-id="element-178">
                        {option.price}
                      </span>
                    </div>

                    <AnimatePresence data-id="element-179">
                      {isSelected && <motion.ul initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} className="space-y-2 overflow-hidden border-t border-white/10 pt-3" data-id="element-180">
                          {option.features.map((f, idx) => <li key={idx} className="flex items-start text-sm text-white/80" data-id="element-181">
                              <Check className="w-4 h-4 text-amber mr-2 flex-shrink-0 mt-0.5" data-id="element-182" />
                              <span data-id="element-183">{f}</span>
                            </li>)}
                        </motion.ul>}
                    </AnimatePresence>
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-184">
          <a href={selectedOption.url} target="_blank" rel="noopener noreferrer" className="block w-full bg-amber hover:bg-amber-dark text-wood-dark font-black text-lg md:text-xl text-center py-5 rounded-2xl transition-all duration-300 hover:-translate-y-1 shadow-[0_8px_25px_rgba(245,197,66,0.3)]" data-id="element-185">
            → {selectedOption.cta}
          </a>
        </motion.div>

        <div className="flex flex-wrap justify-center items-center gap-4 mt-8 text-xs text-white/50 font-medium" data-id="element-186">
          <span className="flex items-center" data-id="element-187">
            <ShieldCheck className="w-4 h-4 mr-1 text-amber" data-id="element-188" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-189">
            <Check className="w-4 h-4 mr-1 text-amber" data-id="element-190" /> Acceso en 5 min
          </span>
          <span className="flex items-center" data-id="element-191">
            <ShieldCheck className="w-4 h-4 mr-1 text-amber" data-id="element-192" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-193">
            <Check className="w-4 h-4 mr-1 text-amber" data-id="element-194" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}